import React, { useState } from 'react';
import { AppHeader } from './../AppHeader/AppHeader';
import { SideNavigation } from './../SideNavigation/SideNavigation';
import { Footer } from './../Footer/Footer';
import { useStyles } from './Layout.styles';
import { useSelector } from 'react-redux';
import { RootState } from 'app/store/types';
import {
  useResetFiltersOnOrganizationChange,
  useScreen,
} from 'app/shared/hooks';
import { themeLayout } from 'app/shared/theme';
import { useLocation } from 'react-router';
import { Routes } from 'types';

interface ILayout {
  children: React.JSX.Element | React.JSX.Element[];
  withSideNavigation?: boolean;
  isLoggedIn?: boolean;
}

export const Layout = ({
  children,
  withSideNavigation = true,
  isLoggedIn,
}: ILayout) => {
  const [sideNavWidth, setSideNavWidth] = useState(
    `${themeLayout.sideNavWidth}px`,
  );
  const { classes } = useStyles();
  const isSideNavOpen = useSelector(
    (state: RootState) => state.layout.isSideNavOpen,
  );
  const location = useLocation();
  const { isMobile } = useScreen(themeLayout.breakpointBig);

  useResetFiltersOnOrganizationChange();

  return (
    <div
      className={
        isMobile && location.pathname === Routes.Profile
          ? classes.mainWrapperMobileProfile
          : classes.mainWrapper
      }
      data-testid="mainWrapper"
    >
      {isLoggedIn !== false && <AppHeader />}
      {withSideNavigation && (
        <SideNavigation setSideNavWidth={setSideNavWidth} />
      )}
      <div
        className={classes.pageWrapper}
        data-testid="pageWrapper"
        style={{
          marginLeft:
            isSideNavOpen && !isMobile && withSideNavigation
              ? sideNavWidth
              : '52px',
        }}
      >
        {children}
      </div>
      <Footer />
    </div>
  );
};
